module.exports = __webpack_public_path__ + "img/Ycafe.24aea6ce.jpg";